<script setup>
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { useStore } from 'vuex';
import { useAlert } from 'dashboard/composables';
import BotsAPI from 'dashboard/api/bots';

// Sprint #46: banner sticky no header da conversa quando ha BmtBotSession
// :active (auto-dispatch ou agente IA respondendo). Espelha o
// ChannelDisconnectedBanner. Avisa o atendente humano + permite assumir.
const props = defineProps({
  conversationId: { type: [Number, String], required: true },
});

const store = useStore();
const byConversationId = useMapGetter('bmtBotActivity/byConversationId');

const session = computed(() => byConversationId.value?.[props.conversationId]);
const isBotActive = computed(() => !!session.value);

const botName = computed(() => session.value?.bot_name || 'Bot');
const botColor = computed(() => session.value?.bot_color || '#8B5CF6');
const triggeredBy = computed(() => session.value?.triggered_by_user_name);

// Texto branco sobre fundo do bot (bot.color costuma ser saturada).
const textColor = '#ffffff';

const pauseAgent = async () => {
  if (!session.value?.id) return;
  // eslint-disable-next-line no-alert
  if (
    !window.confirm(
      `Pausar o agente "${botName.value}"? Você vai assumir o atendimento.`
    )
  ) {
    return;
  }
  try {
    await BotsAPI.cancelBotSession(session.value.id);
    // Refresh imediato do polling pra o banner sumir na hora.
    store.dispatch('bmtBotActivity/fetch');
    useAlert('Agente pausado. Você assumiu o atendimento.');
  } catch (e) {
    useAlert('Falha ao pausar o agente. Tente novamente.');
  }
};
</script>

<template>
  <div
    v-if="isBotActive"
    class="sticky top-0 z-20 flex items-center gap-3 px-4 py-2.5 border-b border-black/10"
    :style="{ backgroundColor: botColor, color: textColor }"
  >
    <span class="text-lg shrink-0">🤖</span>
    <div class="flex flex-col flex-1 min-w-0">
      <span class="text-sm font-semibold flex items-center gap-1.5">
        Em atendimento pelo agente {{ botName }}
        <span class="bmt-typing">
          <span></span><span></span><span></span>
        </span>
      </span>
      <span v-if="triggeredBy" class="text-xs opacity-90">
        Disparado por {{ triggeredBy }}
      </span>
    </div>
    <button
      class="text-xs font-semibold px-3 py-1.5 rounded bg-white/20 hover:bg-white/30 transition-colors whitespace-nowrap"
      :style="{ color: textColor }"
      @click="pauseAgent"
    >
      Assumir / Pausar
    </button>
  </div>
</template>

<style scoped>
.bmt-typing {
  display: inline-flex;
  align-items: center;
  gap: 2px;
}
.bmt-typing span {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: currentColor;
  opacity: 0.6;
  animation: bmtTypingBounce 1.4s infinite ease-in-out;
}
.bmt-typing span:nth-child(2) {
  animation-delay: 0.2s;
}
.bmt-typing span:nth-child(3) {
  animation-delay: 0.4s;
}
@keyframes bmtTypingBounce {
  0%,
  60%,
  100% {
    transform: translateY(0);
    opacity: 0.4;
  }
  30% {
    transform: translateY(-3px);
    opacity: 1;
  }
}
</style>
